import React, { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { db } from './firebase-config';
import './Home.css';

function HomeWorkedWith() {
  const [artists, setArtists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadArtists = async () => {
      setIsLoading(true);
      try {
        const artistsRef = ref(db, 'artists');
        const snapshot = await get(artistsRef);
        
        if (snapshot.exists()) {
          const artistsData = snapshot.val();
          const artistsList = Object.keys(artistsData).map(key => ({
            id: key,
            ...artistsData[key]
          }));
          setArtists(artistsList);
        } else {
          setArtists([]);
        }
      } catch (err) {
        console.error('Fehler beim Laden der Artists:', err);
        setError('Fehler beim Laden der Daten.');
      } finally {
        setIsLoading(false);
      }
    };

    loadArtists();
  }, []);

  // Formatierung von Zahlen mit Tausendertrennzeichen
  const formatNumber = (num) => {
    if (!num) return '';
    return new Intl.NumberFormat('de-DE').format(num);
  };

  return (
    <div className="home-worked-with">
      <h2 className="home-worked-with__title">Artists we worked with</h2>
      
      {isLoading ? (
        <div className="home-worked-with__loading">Lädt...</div>
      ) : error ? (
        <div className="home-worked-with__error">{error}</div>
      ) : artists.length > 0 ? (
        <div className="home-worked-with__grid">
          {artists.map(artist => (
            <a 
              key={artist.id} 
              href={artist.link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="home-worked-with__item"
            >
              <div className="home-worked-with__image-container">
                <img 
                  src={artist.image} 
                  alt={artist.name} 
                  className="home-worked-with__image" 
                  loading="lazy" 
                />
                <div className="home-worked-with__name">{artist.name}</div>
                
                <div className="home-worked-with__stats">
                  {artist.spotifyListeners && (
                    <div className="home-worked-with__stat home-worked-with__stat--spotify">
                      <i className="home-worked-with__icon home-worked-with__icon--spotify"></i>
                      {formatNumber(artist.spotifyListeners)}
                    </div>
                  )}
                  
                  {artist.instagramFollowers && (
                    <div className="home-worked-with__stat home-worked-with__stat--instagram">
                      <i className="home-worked-with__icon home-worked-with__icon--instagram"></i>
                      {formatNumber(artist.instagramFollowers)}
                    </div>
                  )}
                </div>
              </div>
            </a>
          ))}
        </div>
      ) : (
        <div className="home-worked-with__empty">Keine Künstler gefunden.</div>
      )}
    </div>
  );
}

export default HomeWorkedWith; 